export default __webpack_public_path__ + "static/media/ok-status.d1102441.svg";